import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import {setCookie,getCookie,delCookie} from './common/js/cookie.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'


import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.prototype.$cookie={setCookie,getCookie,delCookie};
Vue.prototype.$user='admin';

//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    delCookie('login');
    delCookie('user');
  }
  let login = getCookie('login');
  if (!login && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js